import { refundMethods } from '@reveni-io/reveni-ui'

import { getEmptyTranslations, getTranslations } from '@/configuration/pages/ConfigurationPage/helpers'

export const getTimeValue = days => {
  if (days) {
    const daysFormatted = parseInt(days?.split(' ')?.[0])

    if (daysFormatted < 30) {
      return { type: 'days', number: daysFormatted.toString() }
    } else if (daysFormatted >= 30 && daysFormatted < 365) {
      if (Number.isInteger(daysFormatted / 30)) {
        return { type: 'months', number: (daysFormatted / 30).toString() }
      } else {
        return { type: 'days', number: daysFormatted.toString() }
      }
    } else if (daysFormatted >= 365) {
      if (Number.isInteger(daysFormatted / 365)) {
        return { type: 'years', number: (daysFormatted / 365).toString() }
      } else {
        return { type: 'days', number: daysFormatted.toString() }
      }
    }
  }

  return { number: null, type: null }
}

export const getDurationInDays = (type, number) => {
  if (type && number && type === 'years') return number * 365
  if (type && number && type === 'months') return number * 30
  if (type && number && type === 'days') return number
  return 0
}

export const getRefundMethodPayload = ({
  refundMethod,
  useCustomName,
  customNames,
  instantAllowed,
  duration,
  extraValue,
  extraValueType,
  minEligibleRefundAmount,
  maxExtraAmount,
  supportedLanguages,
  discountCombinations,
  allowExtraWhenPaidWithCredit,
}) => {
  const payload = {
    ...refundMethod,
    instant_allowed: instantAllowed,
    display: useCustomName
      ? getTranslations(supportedLanguages, customNames)
      : getEmptyTranslations(supportedLanguages),
  }

  if (refundMethod.name === refundMethods.storeCredit) {
    payload.duration = `${getDurationInDays(duration.type, duration.number)} 00:00:00`
    payload.extra_value = extraValue
    payload.extra_value_type = extraValueType
    payload.min_eligible_refund_amount = minEligibleRefundAmount
    payload.max_extra_amount = maxExtraAmount
    payload.discount_combinations = discountCombinations
    payload.allow_extra_when_paid_with_credit = allowExtraWhenPaidWithCredit
  }

  if (refundMethod.name === refundMethods.giftCard) {
    payload.duration = duration.type ? `${getDurationInDays(duration.type, duration.number)} 00:00:00` : undefined
    payload.extra_value = extraValue
    payload.extra_value_type = extraValueType
    payload.min_eligible_refund_amount = minEligibleRefundAmount
    payload.max_extra_amount = maxExtraAmount
    payload.allow_extra_when_paid_with_credit = allowExtraWhenPaidWithCredit
  }

  return payload
}

export const isValidityAndExtraCreditMethod = refundMethod => {
  return refundMethod.name === refundMethods.storeCredit || refundMethod.name === refundMethods.giftCard
}

export const getRefundMethodFormValues = (refundMethod, languages) => {
  const display = getTranslations(languages, refundMethod.display)
  const formValues = {
    ...refundMethod,
    display,
    useCustomName: Object.values(display).some(value => value !== null),
  }

  if (!isValidityAndExtraCreditMethod(refundMethod)) return formValues

  return {
    ...formValues,
    duration: getTimeValue(refundMethod.duration),
    extra_value: Number(refundMethod.extra_value),
    min_eligible_refund_amount: Number(refundMethod.min_eligible_refund_amount),
    max_extra_amount: Number(refundMethod.max_extra_amount),
  }
}

export const getExpirationDuration = value => {
  return value === 'noExpires' ? { number: null, type: null } : { number: 0, type: 'days' }
}

export const getExtraValueTypeChanges = extraValueType => {
  return { extra_value_type: extraValueType, extra_value: 0, min_eligible_refund_amount: 0, max_extra_amount: 0 }
}

export const getDiscountCombinations = (discountCombinations, discountType, checked) => {
  if (checked) return [...discountCombinations, discountType]

  return discountCombinations.filter(discount => discount !== discountType)
}
